/* Diagnostic Azalée Para — moteur du quiz.
   Données : az-quiz-tree.json (parcours) + az-quiz-data.json (index du catalogue). */
(function () {
  'use strict';

  var BABY = 1, KID = 2, TEEN = 4, ADULT = 8, ALLAGES = 16, OLDONLY = 32;
  var SKIN = { dry: 1, oily: 2, problem: 4, normal: 8, sens: 16, red: 32, mature: 64, all: 128 };
  var EFF = { hyd: 1, nour: 2, prot: 4, aage: 8, bright: 16, spot: 32, soothe: 64, clean: 128, exfol: 256, purify: 512, acne: 1024, repair: 2048, eyes: 4096, firm: 8192, smooth: 16384, tan: 32768, scar: 65536, strech: 131072, cell: 262144 };
  var HAIR = { dry: 1, oily: 2, damaged: 4, sens: 8, normal: 16, loss: 32, curly: 64, fine: 128, dull: 256, colored: 512, all: 1024 };
  var FOCUS = { energy: 1, immune: 2, bones: 4, hair: 8, skin: 16, brain: 32, digest: 64, heart: 128, nails: 256, weight: 512, prenatal: 1024 };
  var FLAG = { retinoid: 1, acid: 2, essoil: 4, tinted: 8 };

  var SAFE_GROSS = ['visage', 'corps', 'capillaire', 'solaire', 'hygiene', 'complements', 'famille'];
  var SAFE_SENS = ['visage', 'corps', 'capillaire', 'solaire', 'hygiene', 'famille'];
  var NO_PREF = ['sante', 'bijoux'];
  var MIN_UNI = 4, MIN_OPT = 3, FLOW = ['age', 'uni', 'need', 'goal', 'safety', 'pref', 'routine'];

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function mask(map, codes) { var m = 0; (codes || []).forEach(function (c) { m |= map[c] || 0; }); return m; }
  function bits(n) { var c = 0; while (n) { c += n & 1; n >>>= 1; } return c; }
  function money(v) { return Number(v).toFixed(3) + ' DT'; }

  function Quiz(root) {
    this.root = root;
    this.panel = root.querySelector('[data-quiz-panel]');
    this.treeUrl = root.getAttribute('data-tree-url');
    this.dataUrl = root.getAttribute('data-data-url');
    this.T = null; this.D = null; this.colIdx = {};
    this.st = this.fresh(); this.history = []; this.cache = {}; this.memo = {};
    this.started = false;
    this.bindLazyLoad();
  }

  Quiz.prototype.fresh = function () { return { age: null, uni: null, need: null, goal: null, safety: null, pref: null, routine: null }; };

  Quiz.prototype.bindLazyLoad = function () {
    var self = this;
    this.showLoading();
    var go = function () { if (!self.started) { self.started = true; self.load(); } };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '700px' });
      io.observe(this.root);
    } else { go(); }
    this.root.addEventListener('pointerdown', go, { once: true });
  };

  Quiz.prototype.showLoading = function () { this.panel.innerHTML = '<div class="az-quiz-pane"><p class="az-quiz-note">Préparation de votre diagnostic…</p></div>'; };

  Quiz.prototype.load = function () {
    var self = this;
    Promise.all([
      fetch(this.treeUrl).then(function (r) { return r.json(); }),
      fetch(this.dataUrl).then(function (r) { return r.json(); })
    ]).then(function (res) {
      self.T = res[0];
      self.index(res[1]);
      self.bind();
      self.go('age', false);
    }).catch(function () {
      self.panel.innerHTML = '<div class="az-quiz-pane"><p class="az-quiz-note">Le diagnostic est momentanément indisponible. <a href="/collections/all">Voir tous nos produits</a>.</p></div>';
    });
  };

  Quiz.prototype.index = function (raw) {
    var self = this;
    raw.cols.forEach(function (h, i) { self.colIdx[h] = i; });
    this.cats = raw.cats;
    this.D = raw.p.map(function (r) {
      var cs = {}; r[6].forEach(function (i) { cs[i] = 1; });
      return { h: r[0], g: r[1], s: r[2], f: r[3], r: r[4], o: r[5], cs: cs, k: r[7], x: r[8], price: r[9], cmp: r[10], a: r[11], cat: raw.cats[r[7]] || '' };
    });
  };

  Quiz.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-opt]');
      if (opt && self.root.contains(opt)) { self.choose(opt.getAttribute('data-step'), opt.getAttribute('data-opt')); return; }
      if (e.target.closest('[data-quiz-back]')) { self.back(); return; }
      if (e.target.closest('[data-quiz-reset]')) { self.reset(); }
    });
  };

  /* ---------- Règles de correspondance ---------- */
  Quiz.prototype.inCol = function (p, handle) { var i = this.colIdx[handle]; return i !== undefined && !!p.cs[i]; };

  Quiz.prototype.ageOk = function (p, age) {
    var g = p.g, ev = g & 31, old = (g & OLDONLY) > 0;
    if (age === 'bebe') return (g & (BABY | ALLAGES)) > 0 && !old;
    if (age === 'enfant') return (g & (KID | ALLAGES)) > 0 && !old;
    if (age === 'ado') return !old && (ev === 0 || (g & (TEEN | ADULT | ALLAGES)) > 0);
    if (ev === 0) return true;
    if (age === 'senior') return (g & (ADULT | ALLAGES)) > 0;
    return (g & (ADULT | ALLAGES | TEEN)) > 0;
  };

  // Retourne le nombre de critères satisfaits (0 = pas de correspondance). Nœud sans critère = 1.
  Quiz.prototype.nodeScore = function (n, p) {
    if (!n) return 1;
    var self = this, hit = 0, crit = 0;
    if (n.notcol && n.notcol.some(function (h) { return self.inCol(p, h); })) return 0;
    if (n.col) { crit++; if (n.col.some(function (h) { return self.inCol(p, h); })) hit++; }
    if (n.all) { crit++; if (n.all.every(function (h) { return self.inCol(p, h); })) hit++; }
    if (n.eff) { crit++; if (p.f & mask(EFF, n.eff)) hit++; }
    if (n.skin) { crit++; if (p.s & mask(SKIN, n.skin)) hit++; }
    if (n.hair) { crit++; if (p.r & mask(HAIR, n.hair)) hit++; }
    if (n.focus) { crit++; if (p.o & mask(FOCUS, n.focus)) hit++; }
    if (n.flag) { crit++; if (p.x & mask(FLAG, n.flag)) hit++; }
    if (n.cat) { crit++; if (n.cat.some(function (c) { return p.cat.indexOf(c) !== -1; })) hit++; }
    return crit === 0 ? 1 : hit;
  };

  Quiz.prototype.uniNode = function (id) { return (this.T.universes || []).filter(function (u) { return u.id === id; })[0] || null; };
  Quiz.prototype.needNode = function (u, id) { return u && id ? (u.needs || []).filter(function (n) { return n.id === id; })[0] || null : null; };
  Quiz.prototype.goalList = function (u, need) { return need && need.kids ? need.kids : (u && u.goals) || []; };
  Quiz.prototype.goalNode = function (u, need, id) { return id ? this.goalList(u, need).filter(function (g) { return g.id === id; })[0] || null : null; };
  Quiz.prototype.allowed = function (node, age) { return !node.ages || node.ages.indexOf(age) !== -1; };

  Quiz.prototype.pool = function (age, uni, need, goal) {
    var self = this;
    return this.D.filter(function (p) {
      return p.a && self.ageOk(p, age) && self.nodeScore(uni, p) && (!need || self.nodeScore(need, p)) && (!goal || self.nodeScore(goal, p));
    });
  };

  /* ---------- Options de chaque étape (toujours cohérentes avec les réponses précédentes) ---------- */
  Quiz.prototype.options = function (step) {
    var self = this, st = this.st, T = this.T, out = [];
    var key = step + '|' + [st.age, st.uni, st.need, st.goal].join('|');
    if (this.memo[key]) return this.memo[key];
    if (step === 'age') {
      out = T.ages.map(function (a) { return { id: a.id, label: a.label, sub: a.sub }; });
    } else if (step === 'uni') {
      T.universes.forEach(function (u) {
        if (!self.allowed(u, st.age)) return;
        if (self.pool(st.age, u).length < MIN_UNI) return;
        var hasNeed = !(u.needs && u.needs.length) || u.needs.some(function (n) { return self.allowed(n, st.age) && self.pool(st.age, u, n).length >= MIN_OPT; });
        if (hasNeed) out.push({ id: u.id, label: u.label, icon: u.icon });
      });
    } else if (step === 'need') {
      var u = this.uniNode(st.uni);
      (u.needs || []).forEach(function (n) {
        if (!self.allowed(n, st.age)) return;
        if (self.pool(st.age, u, n).length >= MIN_OPT) out.push({ id: n.id, label: n.label });
      });
    } else if (step === 'goal') {
      var u2 = this.uniNode(st.uni), n2 = this.needNode(u2, st.need);
      this.goalList(u2, n2).forEach(function (g) {
        if (!self.allowed(g, st.age)) return;
        if (g.notNeed && g.notNeed.indexOf(st.need) !== -1) return;
        if (self.pool(st.age, u2, n2, g).length >= MIN_OPT) out.push({ id: g.id, label: g.label });
      });
    } else if (step === 'safety') {
      var okG = SAFE_GROSS.indexOf(st.uni) !== -1 && st.need !== 'grossesse' && st.need !== 'maman';
      var okS = SAFE_SENS.indexOf(st.uni) !== -1;
      var seen = {};
      T.safety.forEach(function (s) {
        if (s.ages && s.ages.indexOf(st.age) === -1) return;
        if (s.id === 'grossesse' && !okG) return;
        if (s.id === 'sens' && !okS) return;
        if (seen[s.id]) return; seen[s.id] = 1;
        out.push({ id: s.id, label: s.label });
      });
    } else if (step === 'pref') {
      out = NO_PREF.indexOf(st.uni) !== -1 ? [] : T.pref.map(function (p) { return { id: p.id, label: p.label }; });
    } else if (step === 'routine') {
      var size = this.pool(st.age, this.uniNode(st.uni), this.needNode(this.uniNode(st.uni), st.need), this.goalNode(this.uniNode(st.uni), this.needNode(this.uniNode(st.uni), st.need), st.goal)).length;
      out = size < 4 ? [] : T.routine.map(function (r) { return { id: r.id, label: r.label }; });
    }
    this.memo[key] = out;
    return out;
  };

  Quiz.prototype.question = function (step) {
    var u = this.uniNode(this.st.uni);
    if (step === 'need') return (u && u.q3) || 'Quel est votre besoin ?';
    if (step === 'goal') return (u && u.q4) || 'Une précision ?';
    return this.T.q[step];
  };

  /* ---------- Navigation ---------- */
  Quiz.prototype.nextStepAfter = function (step) {
    var i = FLOW.indexOf(step) + 1;
    for (; i < FLOW.length; i++) {
      var s = FLOW[i], opts = this.options(s);
      if (!opts.length) { this.autoSkip(s, null); continue; }
      if (opts.length === 1 && (s === 'uni' || s === 'need')) { this.st[s] = opts[0].id; this.history.push(s); continue; }
      if (opts.length === 1 && s === 'goal') { this.autoSkip(s, null); continue; }
      if (opts.length === 1 && s === 'safety') { this.st.safety = opts[0].id; continue; }
      return s;
    }
    return 'results';
  };

  Quiz.prototype.autoSkip = function (s) {
    if (s === 'safety') this.st.safety = 'none';
    if (s === 'pref') this.st.pref = 'efficace';
    if (s === 'routine') this.st.routine = 'equilibre';
  };

  Quiz.prototype.choose = function (step, id) {
    this.st[step] = id;
    if (this.history[this.history.length - 1] !== step) this.history.push(step);
    // une réponse modifiée invalide les réponses suivantes
    var from = FLOW.indexOf(step) + 1;
    for (var i = from; i < FLOW.length; i++) this.st[FLOW[i]] = null;
    this.memo = {};
    var btn = this.root.querySelector('[data-opt="' + id + '"][data-step="' + step + '"]');
    if (btn) btn.classList.add('is-selected');
    var self = this;
    setTimeout(function () { var nxt = self.nextStepAfter(step); self.go(nxt, true); }, 140);
  };

  Quiz.prototype.back = function () {
    if (!this.history.length) return;
    var step = this.history.pop();
    var i = FLOW.indexOf(step);
    for (var j = i; j < FLOW.length; j++) this.st[FLOW[j]] = null;
    this.memo = {};
    while (this.history.length && this.options(step).length < 2 && step !== 'age') { step = this.history.pop(); for (var k = FLOW.indexOf(step); k < FLOW.length; k++) this.st[FLOW[k]] = null; }
    this.go(step, true);
  };

  Quiz.prototype.reset = function () {
    // Efface toutes les réponses, la mémoire des calculs et les produits chargés : le parcours repart de zéro.
    this.st = this.fresh(); this.history = []; this.cache = {}; this.memo = {};
    try { Object.keys(sessionStorage).concat(Object.keys(localStorage)).forEach(function (k) { if (k.indexOf('az_quiz') === 0) { sessionStorage.removeItem(k); localStorage.removeItem(k); } }); } catch (e) { /* stockage indisponible */ }
    this.root.classList.remove('is-results');
    this.go('age', true);
  };

  Quiz.prototype.progress = function () {
    var done = 0; var self = this;
    FLOW.forEach(function (s) { if (self.st[s]) done++; });
    return Math.min(100, Math.round((done / FLOW.length) * 100));
  };

  Quiz.prototype.go = function (step, userInitiated) {
    if (step === 'results') { this.results(); return; }
    var opts = this.options(step);
    var self = this, n = this.history.length + 1;
    var canBack = this.history.length > 0;
    var html = '<div class="az-quiz-pane">' +
      '<div class="az-quiz-meta"><span class="az-quiz-count">Question ' + n + '</span>' +
      (canBack ? '<button type="button" class="az-quiz-back" data-quiz-back>← Retour</button>' : '') + '</div>' +
      '<div class="az-quiz-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + this.progress() + '"><i style="width:' + this.progress() + '%"></i></div>' +
      '<h3 class="az-quiz-q" tabindex="-1">' + esc(this.question(step)) + '</h3>' +
      '<div class="az-quiz-options' + (step === 'uni' || step === 'age' ? ' is-grid' : '') + '">' +
      opts.map(function (o) {
        return '<button type="button" class="az-quiz-option' + (self.st[step] === o.id ? ' is-selected' : '') + '" data-step="' + step + '" data-opt="' + esc(o.id) + '">' +
          (o.icon ? '<span class="az-quiz-uicon" aria-hidden="true">' + o.icon + '</span>' : '') +
          '<span class="az-quiz-label">' + esc(o.label) + (o.sub ? '<small>' + esc(o.sub) + '</small>' : '') + '</span></button>';
      }).join('') + '</div>' +
      (n > 1 ? '<button type="button" class="az-quiz-restart" data-quiz-reset>Recommencer</button>' : '') + '</div>';
    this.panel.innerHTML = html;
    if (userInitiated) { var q = this.panel.querySelector('.az-quiz-q'); if (q) q.focus({ preventScroll: true }); }
  };

  /* ---------- Classement des produits ---------- */
  Quiz.prototype.rank = function () {
    var self = this, st = this.st;
    var uni = this.uniNode(st.uni), need = this.needNode(uni, st.need), goal = this.goalNode(uni, need, st.goal);
    var note = '';
    var avoidRisk = st.safety === 'grossesse' || st.safety === 'sens' || st.age === 'bebe' || st.age === 'enfant' || st.age === 'ado';
    var riskMask = st.safety === 'grossesse' ? 7 : (st.age === 'ado' && st.safety !== 'sens' ? 1 : 3);

    function candidates(n, g) {
      var list = self.D.filter(function (p) {
        if (!p.a || !self.ageOk(p, st.age)) return false;
        if (!self.nodeScore(uni, p)) return false;
        if (n && !self.nodeScore(n, p)) return false;
        if (g && !self.nodeScore(g, p)) return false;
        if (st.safety === 'grossesse' && st.uni === 'complements' && !(self.inCol(p, 'grossesse-allaitement') || (p.o & FOCUS.prenatal))) return false;
        return true;
      });
      if (avoidRisk) { var safe = list.filter(function (p) { return !(p.x & riskMask); }); if (safe.length >= 3) list = safe; }
      return list;
    }

    var list = candidates(need, goal);
    if (list.length < 3 && goal) { list = candidates(need, null); note = 'Sélection élargie à votre besoin principal.'; }
    if (list.length < 3 && need) { list = candidates(null, null); note = 'Sélection élargie à l’univers choisi.'; }

    var scored = list.map(function (p) {
      var sc = self.nodeScore(uni, p) * 1 + (need ? self.nodeScore(need, p) * 2 : 0) + (goal ? self.nodeScore(goal, p) * 3 : 0);
      if (st.age === 'bebe' && (p.g & BABY)) sc += 3;
      if (st.age === 'enfant' && (p.g & KID)) sc += 3;
      if (st.age === 'ado' && (p.g & TEEN)) sc += 2;
      if ((st.age === 'adulte' || st.age === 'senior') && (p.g & ADULT)) sc += 1;
      if (st.age === 'senior' && (p.s & SKIN.mature)) sc += 1;
      if (st.safety === 'sens') { if (p.s & (SKIN.sens | SKIN.red)) sc += 3; if (p.f & EFF.soothe) sc += 1.5; }
      if (st.safety === 'grossesse' && self.inCol(p, 'grossesse-allaitement')) sc += 4;
      if (st.pref === 'efficace') { sc += Math.min(2, bits(p.f) * 0.4); }
      if (st.pref === 'doux') { if (p.s & SKIN.sens) sc += 2; if (p.f & EFF.soothe) sc += 1.5; if (p.x & 3) sc -= 3; }
      if (st.pref === 'prix') sc -= p.price / 20;
      if (p.cmp) sc += 0.6;
      return { p: p, sc: sc };
    });
    scored.sort(function (a, b) { return b.sc - a.sc || a.p.price - b.p.price; });
    return { items: scored.map(function (s) { return s.p; }), note: note };
  };

  Quiz.prototype.fetchProduct = function (h) {
    var self = this;
    if (this.cache[h]) return Promise.resolve(this.cache[h]);
    return fetch('/products/' + h + '.js', { cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (j && j.available) { self.cache[h] = j; return j; }
      return null;
    }).catch(function () { return null; });
  };

  Quiz.prototype.pickDiverse = function (list, n) {
    var out = [], seen = {};
    list.forEach(function (p) { if (out.length < n && !seen[p.cat]) { seen[p.cat] = 1; out.push(p); } });
    list.forEach(function (p) { if (out.length < n && out.indexOf(p) === -1) out.push(p); });
    return out;
  };

  /* ---------- Résultats ---------- */
  Quiz.prototype.results = function () {
    var self = this, st = this.st;
    this.root.classList.add('is-results');
    this.panel.innerHTML = '<div class="az-quiz-pane"><h3 class="az-quiz-q" tabindex="-1">Votre sélection</h3><p class="az-quiz-note">Recherche des produits adaptés…</p></div>';
    var ranked = this.rank();
    var take = ranked.items.slice(0, 14);
    Promise.all(take.map(function (p) { return self.fetchProduct(p.h); })).then(function (details) {
      var ok = []; take.forEach(function (p, i) { if (details[i]) ok.push({ meta: p, js: details[i] }); });
      self.renderResults(ok, ranked.note);
    });
  };

  Quiz.prototype.chips = function () {
    var T = this.T, st = this.st, out = [];
    var age = T.ages.filter(function (a) { return a.id === st.age; })[0]; if (age) out.push(age.label + (age.sub ? ' · ' + age.sub : ''));
    var u = this.uniNode(st.uni); if (u) out.push(u.label);
    var n = this.needNode(u, st.need); if (n) out.push(n.label);
    var g = this.goalNode(u, n, st.goal); if (g) out.push(g.label);
    if (st.safety && st.safety !== 'none') { var s = T.safety.filter(function (x) { return x.id === st.safety && (!x.ages || x.ages.indexOf(st.age) !== -1); })[0]; if (s) out.push(s.label); }
    var pr = T.pref.filter(function (x) { return x.id === st.pref; })[0]; if (pr && NO_PREF.indexOf(st.uni) === -1) out.push(pr.label);
    return out;
  };

  Quiz.prototype.renderResults = function (ok, note) {
    var self = this, st = this.st;
    var head = '<div class="az-quiz-pane"><div class="az-quiz-meta"><span class="az-quiz-count">Votre sélection</span><button type="button" class="az-quiz-back" data-quiz-back>← Retour</button></div>' +
      '<div class="az-quiz-bar"><i style="width:100%"></i></div>' +
      '<div class="az-quiz-chips">' + this.chips().map(function (c) { return '<span class="az-quiz-chip">' + esc(c) + '</span>'; }).join('') + '</div>' +
      (note ? '<p class="az-quiz-note">' + esc(note) + '</p>' : '');
    var foot = '<button type="button" class="az-quiz-restart is-strong" data-quiz-reset>↺ Recommencer le diagnostic</button></div>';

    if (!ok.length) {
      var consult = st.safety === 'grossesse' && st.uni === 'complements';
      this.panel.innerHTML = head + '<p class="az-quiz-note">' + (consult
        ? 'Pendant la grossesse ou l’allaitement, un complément se choisit avec un professionnel : notre pharmacien vous conseille personnellement.'
        : 'Aucun produit disponible ne correspond exactement à ces réponses pour le moment.') +
        ' <a href="/pages/contact">Contacter le pharmacien</a> · <a href="/collections/all">Voir tous les produits</a></p>' + foot;
      return;
    }

    var routine = st.routine || 'equilibre';
    var suggested = routine === 'simple' ? 'small' : routine === 'complete' ? 'large' : 'medium';
    var metas = ok.map(function (o) { return o.meta; });
    var byHandle = {}; ok.forEach(function (o) { byHandle[o.meta.h] = o.js; });
    var tiers = [
      { key: 'small', name: 'L’Essentiel', badge: 'Pour démarrer', list: this.pickDiverse(metas, 1) },
      { key: 'medium', name: 'La Sélection Signature', badge: '★ Le plus choisi', list: this.pickDiverse(metas, Math.min(3, metas.length)), featured: true },
      { key: 'large', name: 'Le Rituel Complet', badge: 'Routine complète', list: this.pickDiverse(metas, Math.min(5, metas.length)) }
    ];
    var seen = [];
    tiers = tiers.filter(function (t) {
      var ids = t.list.map(function (p) { return p.h; }).join(',');
      if (t.key !== 'small' && seen.indexOf(ids) !== -1) return false;
      seen.push(ids); return t.list.length > 0;
    });

    var body = '<div class="az-quiz-tiers">' + tiers.map(function (t) {
      var prods = t.list.map(function (p) { return byHandle[p.h]; });
      var total = prods.reduce(function (s, j) { return s + (j.variants.filter(function (v) { return v.available; })[0] || j.variants[0]).price / 100; }, 0);
      return '<div class="az-quiz-tier' + (t.featured ? ' is-featured' : '') + (t.key === suggested ? ' is-suggested' : '') + '" data-tier="' + t.key + '">' +
        '<div class="az-quiz-tier-head"><span>' + t.name + '</span><span class="az-quiz-tier-badge">' + (t.key === suggested && !t.featured ? 'Votre choix' : t.badge) + '</span></div>' +
        '<ul class="az-quiz-tier-list">' + prods.map(function (j) {
          var v = j.variants.filter(function (x) { return x.available; })[0] || j.variants[0];
          var img = j.featured_image ? j.featured_image.replace(/(\.\w+)(\?|$)/, '_120x$1$2') : '';
          return '<li><a href="/products/' + esc(j.handle) + '"><img src="' + esc(img) + '" alt="" loading="lazy" width="44" height="44"><span>' + esc(j.title) + '</span><b>' + money(v.price / 100) + '</b></a></li>';
        }).join('') + '</ul>' +
        '<div class="az-quiz-tier-foot"><b class="az-quiz-tier-price">' + money(total) + '</b><button type="button" class="az-quiz-tier-add" data-add="' + t.key + '">Ajouter la sélection</button></div></div>';
    }).join('') + '</div>';

    this.panel.innerHTML = head + body + foot;
    this.panel.querySelectorAll('[data-add]').forEach(function (btn) {
      var tier = tiers.filter(function (t) { return t.key === btn.getAttribute('data-add'); })[0];
      btn.addEventListener('click', function () { self.addToCart(tier.list.map(function (p) { return byHandle[p.h]; }), btn); });
    });
  };

  Quiz.prototype.addToCart = function (prods, btn) {
    var items = prods.map(function (j) { var v = j.variants.filter(function (x) { return x.available; })[0] || j.variants[0]; return { id: v.id, quantity: 1 }; });
    var label = btn.textContent; btn.disabled = true; btn.textContent = 'Ajout…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓ Ajouté au panier'; btn.classList.add('is-done');
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-count-bubble span[aria-hidden], .cart-count-bubble').forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
        }).catch(function () {});
        setTimeout(function () { btn.disabled = false; btn.textContent = label; btn.classList.remove('is-done'); }, 2600);
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  };

  document.querySelectorAll('[data-az-quiz]').forEach(function (root) { new Quiz(root); });
})();
